exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.emg_alt {\r\n    color: red!important;\r\n    font-weight: bold;\r\n}\r\ntbody > tr td:nth-of-type(even), tbody > tr th:nth-of-type(even) {\r\n    float: none;\r\n}\r\nthead>tr th:nth-of-type(even) {\r\n    text-align: left;\r\n    padding-right: 0px;\r\n}\r\n.table-hover>tbody>tr:hover>td, .table>tbody>tr:hover>td, .table-hover>tbody>tr:hover>th, .table>tbody>tr:hover>th{\r\n     background-color: inherit;\r\n}\r\n.table-hover>tbody>tr:hover>td a, .table>tbody>tr:hover>td a, .table-hover>tbody>tr:hover>th a, .table>tbody>tr:hover>th a{\r\n     text-decoration: none;\r\n     color: inherit;\r\n}\r\n.table-hover>tbody>tr:hover, .table>tbody>tr:hover, .table-hover>tbody>tr:hover, .table>tbody>tr:hover{\r\n     background: #f7f7f7; \r\n     cursor: pointer;\r\n\r\n}\r\n.module .module-content-inner{\r\n     padding-top: 0px;\r\n     padding-bottom: 0px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/dashboard.component.css
// module id = 383
// module chunks = 1